import { Link } from 'react-router-dom'
import { DJ_NAME, NAV_LINKS, SOCIAL_LINKS } from '../data'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer
      style={{
        background: '#080706',
        borderTop: '1px solid rgba(200,169,110,0.1)',
        padding: 'clamp(32px, 5vw, 48px) clamp(16px, 5vw, 32px) 32px',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Top row */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '24px',
            marginBottom: '32px',
            paddingBottom: '28px',
            borderBottom: '1px solid rgba(200,169,110,0.08)',
          }}
        >
          {/* Logo */}
          <Link
            to="/"
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 600,
              fontSize: '18px',
              letterSpacing: '5px',
              color: 'rgba(200,169,110,0.3)',
              textTransform: 'uppercase',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
            onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(200,169,110,0.3)')}
          >
            {DJ_NAME}
          </Link>

          {/* Social links */}
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.platform}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '10px',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  color: 'rgba(200,169,110,0.22)',
                  textDecoration: 'none',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
                onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(200,169,110,0.22)')}
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>

        {/* Bottom row */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
          }}
        >
          <p
            style={{
              fontSize: '11px',
              color: 'rgba(122,112,96,0.4)',
              letterSpacing: '1px',
            }}
          >
            © {year} {DJ_NAME}. All Rights Reserved.
          </p>

          {/* Nav links */}
          <ul
            style={{
              listStyle: 'none',
              display: 'flex',
              gap: '20px',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '10px',
                    letterSpacing: '2px',
                    textTransform: 'uppercase',
                    color: 'rgba(200,169,110,0.2)',
                    textDecoration: 'none',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
                  onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(200,169,110,0.2)')}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/signin"
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '10px',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  color: 'rgba(200,169,110,0.2)',
                  textDecoration: 'none',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = 'var(--gold)')}
                onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(200,169,110,0.2)')}
              >
                Sign In
              </Link>
            </li>
          </ul>

          <p style={{ fontSize: '11px', color: 'rgba(122,112,96,0.2)', letterSpacing: '1px' }}>
            Privacy · Terms
          </p>
        </div>
      </div>
    </footer>
  )
}
